import { render } from "./MetricTableRow.vue?vue&type=template&id=73990de3"
import script from "./MetricTableRow.vue?vue&type=script&lang=js"
export * from "./MetricTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MetricTableRow.vue"]])

export default __exports__